import { Component, ElementRef, Injector, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent, ConfirmationComponent, FirebaseService, Info, InfoService, UploadTypeEnum, UtilHelper } from 'lib-trend-core';
import { BehaviorSubject, delay, Observable } from 'rxjs';

@Component({
    selector: 'info-form-component',
    templateUrl: 'info-form.component.html',
    styleUrl: 'info-form.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InfoFormComponent extends AbstractComponent implements OnInit {

  private loadingSpinnerSubject = new BehaviorSubject<boolean>(false);
  loadingSpinner$: Observable<boolean> = this.loadingSpinnerSubject.asObservable().pipe(delay(700));

  @ViewChild('fileInputFile', { static: false }) inputFile: ElementRef

  info: Info = <Info>{};
  file: File;
  bytes: string;

  breadcrumb = [
    { href: '/company', label: 'Empresas' },
    { label: 'Alterar Empresa' },
  ];

  constructor(
    injector: Injector,
    public dialog: MatDialog,
    public infoService: InfoService,
    public firebaseService: FirebaseService,
  ) {
    super(injector);
    this.info = {} as Info;
    this.setupForm();
  }

  ngOnInit() {
    const idInfo = this.getParam('id');
    if (idInfo) {
      this.isNew = false;
      this.infoService.getById(idInfo).subscribe((info) => {
        this.info = info;
        this.formGroup.patchValue(this.info);
      });
    } else {
      this.info.type = 'IMAGE';
      this.isNew = true;
      this.formGroup.patchValue(this.info);
    }
  }

  private setupForm(): void {
    this.formGroup = this.formBuilder.group({
      name: [null, [Validators.required]],
      type: [null, [Validators.required]],
      content: [null, [Validators.required]],
      contentType: [null, []],
      contentUrl: [null, []],
      actived: [false, [Validators.required]],
      startedAt: [null, [Validators.required]],
      finishedAt: [null, [Validators.required]],
    });
    this.formGroup.valueChanges.subscribe((value) => {
      Object.assign(this.info, value);
    });
  }

  onSubmit() {
    if (!this.formGroup.valid) {
      this.validateAllFormFields(this.formGroup);
      return;
    }

    if (this.isNew) {
      this.infoService.create(this.info).subscribe({
        next: () => {
          this.alertService.success('Usuário criado com sucesso.');
          this.router.navigate(['/info']);
        },
        error: (err) => this.alertService.error(err.error.message),
      });
    } else {
      this.infoService.update(this.info._id, this.info).subscribe({
        next: (value) => {
          this.alertService.success('Atualizada com sucesso.');
          this.router.navigate(['/info']);
        },
        error: (err) => this.alertService.error(err.error.message),
      });
    }
  }

  addImage() {
    this.inputFile.nativeElement.click();
  }

  openFileBrowser(event: any) {
    event.preventDefault();
    const element: HTMLElement = document.getElementById('localImageCompanyForm',) as HTMLElement;
    element.click();
  }

  async onSelectImage(event: Event) {
    this.loadingSpinnerSubject.next(true);

    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];

    if (!file) {
      this.loadingSpinnerSubject.next(false);
      return;
    }

    this.file = file;

    const reader = new FileReader()
    reader.onload = async (e) => {
      const contents = e.target?.result as ArrayBuffer;
      const base64 = UtilHelper.arrayBufferToBase64(contents);
      const filename = new Date().getTime().toString();

      try {
        const snapshot = await this.firebaseService.uploadFile(
          this.file,
          filename,
          UploadTypeEnum.COMPANY,
        );
        this.formGroup.patchValue({ content: snapshot.url, contentType: this.file.type });
      } catch (error) {
        this.alertService.error('Falha ao enviar a imagem.');
      } finally {
        this.loadingSpinnerSubject.next(false);
        input.value = '';
      }
    }

    reader.readAsArrayBuffer(file);
  }

  removeMedia(): void {
    if (this.info.content) {
      const dialogRef = this.dialog.open(ConfirmationComponent, {
        width: '600px',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.loadingSpinnerSubject.next(true);
          this.loading = false;
          this.firebaseService
            .deleteFile(this.info.content)
            .then(() => {
              this.formGroup.patchValue({ image: null });
              this.info.content = null;
              if (this.inputFile?.nativeElement) {
                this.inputFile.nativeElement.value = '';
              }
            })
            .catch((error) => {
              console.error('Erro ao deletar o arquivo:', error);
            })
            .finally(() => {
              this.loadingSpinnerSubject.next(false);
            });
        }
      })
    }
  }

  onImageLoadError(): void {
    this.formGroup.patchValue({ content: null });
    this.info.content = null;
  }

}
